module.exports = __webpack_public_path__ + "static/img/kukai_benefit_item_bg.aa6a133f.png";